/**
 * Environment Configuration
 * Using real Microsoft Entra External ID authentication only
 */

// Always use real authentication - no mock mode
export const USE_MOCK_AUTH = false;

/**
 * Get the API base URL based on environment
 * Returns base URL WITHOUT /api suffix (callers add /api themselves)
 */
export function getApiBaseUrl(): string {
  // Check if we're in development (localhost)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:7071';
  }

  // Production Azure Functions URL
  return 'https://ccstudio-func-prod.azurewebsites.net';
}

export default { USE_MOCK_AUTH, getApiBaseUrl };
